import React from "react";

interface FundoIconProps {
  isUrgent: boolean;
}

export const FundoIcon: React.FC<FundoIconProps> = ({ isUrgent }) => {
  // Cores dinâmicas baseadas na urgência
  const bgColor = isUrgent ? "#FF3B30" : "#FBE2CC";
  const strokeColor = isUrgent ? "#FFDEDC" : "#FFF2E0";
  const iconColor = isUrgent ? "#FFFFFF" : "#ED6C02";

  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill={bgColor} />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke={strokeColor}
        strokeWidth="8"
      />
      <path
        d="M35.987 37.6662H20.012C19.6417 37.6662 19.2713 37.5725 18.9479 37.399C18.4182 37.1131 18.0338 36.6397 17.8604 36.0631C17.687 35.4865 17.7479 34.8771 18.0338 34.3521L26.0167 19.5162C26.4104 18.785 27.1698 18.335 27.9995 18.335C28.8292 18.335 29.5885 18.7896 29.9823 19.5162L37.9698 34.3521C38.1479 34.6803 38.237 35.0459 38.237 35.4209C38.237 36.0209 38.0026 36.5881 37.576 37.01C37.1542 37.4365 36.5917 37.6662 35.987 37.6662ZM20.012 36.1662H35.9917C36.1932 36.1662 36.3807 36.0865 36.5213 35.9459C36.662 35.8053 36.7417 35.6178 36.7417 35.4162C36.7417 35.2943 36.7088 35.1678 36.6526 35.06L28.6604 20.2287C28.4682 19.8725 28.1354 19.835 27.9995 19.835C27.8635 19.835 27.5307 19.8725 27.3385 20.2287L19.351 35.0646C19.2573 35.2428 19.2338 35.4443 19.2948 35.6365C19.351 35.8287 19.4823 35.9881 19.6557 36.0818C19.7635 36.1381 19.8854 36.1662 20.012 36.1662Z"
        fill={iconColor}
      />
      <path
        d="M27.9995 31.6285C27.601 31.6285 27.2682 31.3145 27.2495 30.916L26.9823 25.1973C26.9823 25.1926 26.9823 25.1879 26.9823 25.1832V25.1598C26.9776 24.5973 27.4276 24.1379 27.9901 24.1332C28.0089 24.1332 28.0276 24.1332 28.0464 24.1332C28.6089 24.1567 29.0448 24.6348 29.0167 25.1973L28.7495 30.916C28.7307 31.3145 28.3979 31.6285 27.9995 31.6285Z"
        fill={iconColor}
      />
      <path
        d="M27.9994 34.619C27.4838 34.619 27.0619 34.1971 27.0619 33.6815C27.0619 33.1659 27.4838 32.744 27.9994 32.744C28.5151 32.744 28.9369 33.1659 28.9369 33.6815C28.9369 34.1971 28.5151 34.619 27.9994 34.619Z"
        fill={iconColor}
      />
    </svg>
  );
};
